var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssential(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7172 5.83345C12.9836 7.14087 12.7937 8.50011 12.1793 9.6845C11.5648 10.8689 10.5629 11.8068 9.34057 12.3419C8.11826 12.877 6.74947 12.9768 5.46244 12.6248C4.17542 12.2728 3.04796 11.4903 2.2681 10.4076C1.48823 9.32496 1.10309 8.00767 1.17691 6.67542C1.25072 5.34318 1.77903 4.0765 2.67373 3.08663C3.56843 2.09676 4.77544 1.44353 6.09347 1.23588C7.41151 1.02823 8.76089 1.2787 9.9166 1.94553",
    stroke: "#3555C6",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6.41659L7 8.16659L12.8333 2.33325",
    stroke: "#3555C6",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssential);
export default __webpack_public_path__ + "static/media/Essential.680d8dadff6fa18d6cfcc27cf7ee0734.svg";
export { ForwardRef as ReactComponent };